import { Grid, SelectField, TextAreaField, TextField } from "../Fields";
import { useWizard } from "../WizardContext";
import { OCCUPATIONS, JOB_HOLDER } from "../../../lib/options";

export default function StepEducation() {
  const { data } = useWizard();
  return (
    <Grid>
      <TextField section="candidate" name="highest_qualification" label="Highest educational qualification" required placeholder="e.g. B.Tech, MBA" />
      <TextField section="candidate" name="medium_of_education" label="Medium of education" placeholder="e.g. English" />
      <SelectField section="candidate" name="occupation" label="Occupation" required options={OCCUPATIONS} />
      <TextField section="candidate" name="place_of_work" label="Place of work" />
      {data.candidate.occupation === JOB_HOLDER && (
        <TextAreaField section="candidate" name="job_details" label="Job details" required placeholder="Designation, company, department" className="sm:col-span-2" />
      )}
      <TextField section="candidate" name="annual_income" label="Annual income (in words)" placeholder="e.g. Six lakh rupees" className="sm:col-span-2" />
    </Grid>
  );
}
